<template>
  <div id="container">
    <div class="box_one" style="margin-bottom:5px">
      <cont-top/>
    </div>
    <div class="main" style="margin-bottom:5px">
      <div class="title">
        <div class="title_name"></div>
      </div>

      <div class="main-cont">
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/亚洲宝珀GT宣传片6-team studie.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img4.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:239px;margin:0 auto">
            <el-image
              style="height:17px;width:239px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img5.png')"
              fit="contain">
            </el-image>
          </div>
        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/亚洲宝珀GT宣传片5.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img6.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:148px;margin:0 auto">
            <el-image
              style="height:17px;width:148px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img7.png')"
              fit="contain">
            </el-image>
          </div>
        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/亚洲宝珀GT宣传片4.mp4' )" >
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img8.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:148px;margin:0 auto">
            <el-image
              style="height:17px;width:148px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img9.png')"
              fit="contain">
            </el-image>
          </div>
        </div>

        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/亚洲宝珀GT宣传片3.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img10.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:148px;margin:0 auto">
            <el-image
              style="height:17px;width:148px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img11.png')"
              fit="contain">
            </el-image>
          </div>
        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/亚洲宝珀GT宣传片2.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img51.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:148px;margin:0 auto">
            <el-image
              style="height:17px;width:148px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img52.png')"
              fit="contain">
            </el-image>
          </div>

        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/亚洲宝珀GT宣传片1.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img61.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:148px;margin:0 auto">
            <el-image
              style="height:17px;width:148px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img62.png')"
              fit="contain">
            </el-image>
          </div>
        </div>

        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/RD-type漂移用刹车片追走视频.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img71.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:217px;margin:0 auto">
            <el-image
              style="height:17px;width:217px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img72.png')"
              fit="contain">
            </el-image>
          </div>
        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/LINK机床测试与数据应用.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img81.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:177px;margin:0 auto">
            <el-image
              style="height:17px;width:177px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img82.png')"
              fit="contain">
            </el-image>
          </div>

        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/HC刹车碟制造工艺.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img91.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:133px;margin:0 auto">
            <el-image
              style="height:17px;width:133px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img92.png')"
              fit="contain">
            </el-image>
          </div>
        </div>

        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/GTR35浮动碟套装.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img101.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:128px;margin:0 auto">
            <el-image
              style="height:17px;width:128px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img102.png')"
              fit="contain">
            </el-image>
          </div>
        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/DOT4LV.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img111.png')"
            fit="contain">
          </el-image>
          <div style="height:16px;width:58px;margin:0 auto">
            <el-image
              style="height:16px;width:58px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img112.png')"
              fit="contain">
            </el-image>
          </div>

        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/DIXCEL本社揭秘.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img121.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:118px;margin:0 auto">
            <el-image
              style="height:17px;width:118px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img122.png')"
              fit="contain">
            </el-image>
          </div>
        </div>

        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/D1中国赛内海VS川畑2.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img131.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:171px;margin:0 auto">
            <el-image
              style="height:17px;width:171px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img132.png')"
              fit="contain">
            </el-image>
          </div>
        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/D1中国赛内海VS川畑1.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img141.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:171px;margin:0 auto">
            <el-image
              style="height:17px;width:171px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img142.png')"
              fit="contain">
            </el-image>
          </div>
        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/D1中国内海单走.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img151.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:117px;margin:0 auto">
            <el-image
              style="height:17px;width:117px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img152.png')"
              fit="contain">
            </el-image>
          </div>
        </div>

        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/2019国际汽联亚洲F3年度集锦.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img161.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width: 219px;margin:0 auto">
            <el-image
              style="height:17px;width: 219px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img162.png')"
              fit="contain">
            </el-image>
          </div>
        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/2013CTCC揭幕战雨中混战上海大众333车队王睿夺冠.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img171.png')"
            fit="contain">
          </el-image>
          <div style="height:35px;width:189px;margin:0 auto">
            <el-image
              style="height:35px;width:189px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img172.png')"
              fit="contain">
            </el-image>
          </div>
        </div>
        <div class="item_cont" @click="playVideo( 'https://dixcel.cn/prod/视频/2012赛季上海大众333车队年终集锦.mp4' )">
          <el-image
            style="height:16px;width:267px;margin-bottom:4px"
            :src="require('@/assets/image/moment/WonderfulVideo/img3.png')"
            fit="contain">
          </el-image>
          <el-image
            style="height:178px;width:267px;margin-bottom:15px"
            :src="require('@/assets/image/moment/WonderfulVideo/img181.png')"
            fit="contain">
          </el-image>
          <div style="height:17px;width:259px;margin:0 auto">
            <el-image
              style="height:17px;width:259px;"
              :src="require('@/assets/image/moment/WonderfulVideo/img182.png')"
              fit="contain">
            </el-image>
          </div>
        </div>
      </div>


      <el-dialog title :visible.sync="dialogPlay" width="50%" @close="closeDialog">
         <video :src="videoUrl" controls autoplay class="video" ref="dialogVideo"
         width="100%"></video>
      </el-dialog>

    </div>
    <div class="box_bottom" >
      <cont-bottom/>
    </div>

  </div>
</template>

<script>
import ContTop from './Cont_top'
import ContBottom from '@/views/Components/Cont_bottom'


export default {
  data() {
    return {
      fit : 'contain' ,
      dialogPlay : false ,
      videoUrl : ''  ,
    }
  },
  components : {
    ContTop ,
    ContBottom ,
  } ,

  mounted() {

  }  ,

  methods:{
    // 视频播放
    playVideo( url ) {
      this.videoUrl = url
      this.dialogPlay = true;
      this.$refs.dialogVideo.play();

    },
    closeDialog() {
      this.videoUrl = ""; //清空数据 关闭视频播放
    },
  }
}

</script>

<style lang="stylus" scoped>
.clear:after {
  display: block;
  clear: both;
  content: '';
}

#container
  background-color : #000
  .box_one
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 0 52px;

}
  .main-cont{
    display flex
    flex-wrap wrap
    justify-content space-around
  }
    .item_cont{
      width 267px;
      height 250px;
      margin-bottom 45px
      cursor pointer
    }

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/moment/WonderfulVideo/img1.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 23px 56px 24px 57px;
  box-sizing: border-box;
}

.title_name {
  width: 57px;
  height: 61px;
  background: url('~@/assets/image/moment/WonderfulVideo/img2.png');
  background-repeat: no-repeat;
  background-size: contain;
}

</style>
